import { Component, computed, input, output } from '@angular/core';
import { ISuggestionIcon } from 'src/app/models';
import { UtilsService } from 'src/app/services';
import { TooltipPosition } from '../../tooltip/tooltip-position';
import { NgClass } from '@angular/common';
import { TooltipModule } from '../../tooltip/tooltip.module';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [NgClass, TooltipModule],
})
export class CheckboxComponent {
  readonly id = input<string>();
  readonly value = input<any>();
  readonly text = input<string>();
  readonly ariaLabel = input<string>();
  readonly description = input<string>();
  readonly checked = input<boolean>();
  readonly onChange = output<any>();
  readonly disabled = input<boolean>(false);
  readonly icon = input<ISuggestionIcon | null>();
  readonly tooltipText = input<string>('');
  readonly alwaysShowTooltip = input(false);

  readonly TooltipPosition = TooltipPosition;

  readonly labelId = computed(() => `checkbox-label-${this.id()}`);
  readonly label = computed(() => {
    const text = this.text() || this.value()?.name || '';
    return this.description() ? `${text} - ${this.description()}` : text;
  });
  readonly tooltipContent = computed(() => this.tooltipText() || this.label());

  constructor(public utilsService: UtilsService) {}
}
